import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";

import { itemRouteBuilder, NamedRts } from "@/router";

import { TemplateWorkOrder } from "@/store/modules/templateWorkOrders";
import { filter as Rfilter } from "ramda";

import { genericSort, sortIcon } from "@/components/helpers";

export default defineComponent({
  name: "templateWorkOrders",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = ref(
      "Loading template work orders...Dragging them in from the database...",
    );

    let filter = ref("");

    let sortKey = ref<"template_name" | "template_description">(
      "template_name",
    );
    let sortAsc = ref(true);

    const apiTemplateWorkOrders = computed(() => {
      return $store.getters.templateWorkOrdersForTable as TemplateWorkOrder[];
    });

    const localTemplateWorkOrders = ref<TemplateWorkOrder[]>([]);

    const localSortIcon = (lSortKey: "name" | "client_name") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const templateWorkOrders = computed(() => {
      let tmpResults = [...localTemplateWorkOrders.value];

      if (filter.value !== "") {
        let tmpReg = new RegExp(filter.value, "i");
        tmpResults = Rfilter((item: TemplateWorkOrder) => {
          let nameResult = tmpReg.test(item.template_name);
          let descriptionResult = tmpReg.test(item.template_description);

          return nameResult || descriptionResult;
        }, tmpResults);
      }

      return tmpResults;
    });

    const updateSort = (lSortKey: "template_name" | "template_description") => {
      localTemplateWorkOrders.value = genericSort(
        [...localTemplateWorkOrders.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.templateWorkOrderEditForm, id);
    };

    const buildRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.templateWorkOrderBuildForm, id);
    };

    onMounted(() => {
      const jsConn = new JSConn();
      $store.dispatch("needTemplateWorkOrders", jsConn).then(() => {
        localTemplateWorkOrders.value = [...apiTemplateWorkOrders.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,
      templateWorkOrders,

      filter,
      localSortIcon,
      updateSort,

      editRouteBuilder,
      buildRouteBuilder,
    };
  },
});
